import { withStyles } from "@material-ui/core/styles";
import styles from "./UploadsStyles";
import { Button, Grid, Typography, styled, FormControl, InputLabel, MenuItem, Select, Dialog, DialogTitle, DialogContentText, DialogActions, Box,  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as XLSX from "xlsx";
import dayjs from 'dayjs'
import loader from '../../../../ui-assets/upload_loader.gif'
import error from '../../../../ui-assets/upload_error.gif'
import success from '../../../../ui-assets/upload_success.gif'
import FileOpenIcon from '@mui/icons-material/FileOpen';
import SyncIcon from '@mui/icons-material/Sync';  //dev-trupti on 11-12-2024 
import {httpRequest} from "../../../../ui-utils/api"
import { backendHosts, apiUrl } from '../../../../ui-utils/apiConfig'

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 0.5,
});

const Uploads = ({ classes }) => {
  const [type, setType] = useState("")
  const [file, setFile] = useState("")
  const [enable, setEnable] = useState(false)
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [dialogTittle, setDialogTittle] = useState("")
  const [dialogTittle1, setDialogTittle1] = useState("")
  const [dialogContent, setDialogContent] = useState("")
  const [dialogContent1, setDialogContent1] = useState("")
  const [preview, setPreview] = useState([])
  const [rows, setRows] = useState(0)
  const [columns, setColumns] = useState(null)
  const [fileName, setFileName] = useState("")
  const [payload, setPayload] = useState([])
  const [load, setLoad] = useState(false)

  //dev-trupti on 11-12-2024 
  const errorTitle = "Error uploading the file"
  const gettingUploaded = "Your file is getting uploaded"
  const uploadSuccTitle = "Upload succesful"
  const uploadSuccBody = "Your file is uploaded successfully"
  const errorBody = "Something went wrong"

  const handleClose = () => {
    setOpen(false);
    setOpen1(false) //dev-trupti on 23-12-2024
    setFile("")
    setEnable(false)
    setRows(0)
    setDialogTittle("")
    setDialogContent("")
    setDialogTittle1("") //dev-trupti on 23-12-2024
    setDialogContent1("")
  };

  const handleClose1 = () => {
    setOpen1(false);
    setOpen(false) //dev-trupti on 23-12-2024
    setFile("")
    setEnable(false)
    setRows(0)
    setDialogTittle1("")
    setDialogContent1("")
    setDialogTittle("") //dev-trupti on 23-12-2024
    setDialogContent("")
    setPayload([])
  };

  const handleChange = (event) => {
    setType(event.target.value);
      setEnable(false)
    setFile("")
    setRows(0)
  };

  //A seperate funtion for checking Monthly file upload logic by dev-trupti on 09-01-2025
  const  isValidDateRange =(fromDate, toDate)=>{
    const today = dayjs()
    const isFirstDayOfMonth = today.date() === 1;
    const firstDayOfMonth = today.startOf(isFirstDayOfMonth ? 'month' : 'month').subtract(isFirstDayOfMonth ? 1 : 0, 'month');
    const lastDayOfMonth = today.endOf(isFirstDayOfMonth ? 'month' : 'month').subtract(isFirstDayOfMonth ? 1 : 0, 'month');
    const from = dayjs(fromDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'));
    const to = dayjs(toDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'));
    return (from.isAfter(firstDayOfMonth)|| from.isSame(firstDayOfMonth)) && from.isBefore(lastDayOfMonth) &&
           to.isAfter(firstDayOfMonth) && to.isBefore(lastDayOfMonth) &&
           from.isBefore(to);
}

  const getData = async (e) => {
    let payload = [];
    let fromDate = ""
    let toDate = ""
    const dateFormat = "DD/MM/YYYY"
    const currentDate = dayjs();
    const currentYear = currentDate.year(); //dev-trupti on 09-01-2025
    
    let startOfFinancialYear = dayjs().month(3).date(1);
    
    if (currentDate.isBefore(startOfFinancialYear)) {
      startOfFinancialYear = startOfFinancialYear.subtract(1, 'year');
    }
  
    const endOfFinancialYear = startOfFinancialYear.add(1, 'year').subtract(1, 'day');
    
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet, {
      header: 1,
      range: 1,
      defval: "",
      raw: false,
    });


    //Extracting the Filename and Date
    const confirmFile = jsonData[0][0]
    setFileName(confirmFile)
    const confirmDate = jsonData[1][0]
    let regex = /\d{2}\/\d{2}\/\d{4}/g;
    let dates = confirmDate.match(regex);
    fromDate = dates[0];  
    toDate = dates[1];   
    const fromDayJs = dayjs(fromDate, dateFormat);  //dev-trupti on 09-01-2025
    const toDayJs = dayjs(toDate, dateFormat); 
    if(type === "KYC"){
      if(confirmFile.trim() === "Kyc Report") {
        if (
            (fromDayJs.isAfter(startOfFinancialYear, 'day') || fromDayJs.isSame(startOfFinancialYear, 'day')) &&  // fromDate is on or after the start of the financial year
            (toDayJs.isBefore(endOfFinancialYear, 'day') || toDayJs.isSame(endOfFinancialYear, 'day'))           // toDate is on or before the end of the financial year
          ){            setFile(e.target.files[0].name)
            jsonData.slice(3).forEach((row) => {
              if (row && row.length > 0) {
                payload.push({
                  client_id: row[0] || "",
                  last_trade_date: row[3] || "" ,
                  ledgerbalance: row[4] || "",
                  account_opening_date: row[8] || "" ,
                  lastrecipt: row[11] || "",
                  lastpayment: row[12] || "",
                });
              }
            });
            setEnable(true)
            setColumns(Object.keys(payload[0]))
          } else {
            setDialogTittle(errorTitle)
            setDialogContent(`Please ensure your uploading a current Financial Year KYC report file`) //dev-trupti on 09-01-2025
            setOpen(true)
          } 
      }else{
        setDialogTittle(errorTitle)
        setDialogContent("Please ensure you are uploading a KYC report file")
        setOpen(true)
      }  
    }else if(type === "Monthly Brokerage" || type === "Life Time Brokerage" || type === "Transactions"){
      if(confirmFile.trim() === "Brokerage/Remeshire Report") {
        if(type ==="Monthly Brokerage"){
          if (
            isValidDateRange(fromDate, toDate)
          ) {
            setFile(e.target.files[0].name)
            jsonData.slice(3).forEach((row) => {
              if (row && row.length > 0) {
                const date = row[5] || ""
                const formattedDate = date ? new Date(date).toLocaleDateString('en-US') : "";

                payload.push({
                  client_id: row[0] || "",
                  month: row[3] || "",
                  trading_brokerage: row[2] || "",
                  trade_date: formattedDate,
                  company_code: row[6] || "",
                });
              }
            });
            setEnable(true)
            setColumns(Object.keys(payload[0]))
          } else {
            setDialogTittle(errorTitle)
            setDialogContent("Please ensure your uploading current month file")
            setOpen(true)
          }
          
        }else if(type === "Life Time Brokerage"){
          setFile(e.target.files[0].name)
          jsonData.slice(3).forEach((row) => {
            if (row && row.length > 0) {
              payload.push({
                client_id: row[1] || "",
                total_brokerage: row[3] || "",
                branch: row[4] || "",
                total_remeshire_brokerage: row[5] || "",
                total_net_brokerage: row[7] || "",
              });
            }
          });
          setEnable(true)
          setColumns(Object.keys(payload[0]))
        }else if(type === "Transactions"){ //dev-trupti on 23-12-2024
          setFile(e.target.files[0].name)
          jsonData.slice(3).forEach((row) => {
            if (row && row.length > 0) {
              payload.push({
                client_id: row[0] || "",
                client_name: row[1] || "",
                txdate: row[2] || "",
                brokerage: row[3] || "",
                ownbrk: row[4] || "",
                rembrk: row[5] || "",
                lots: row[6] || "",
                agent_brokerage: row[9] || "",
                agent_id: row[7] || "",
                regional_brokerage: row[12] || "",
                regional_id: row[10] || "",
                zonal_brokerage: row[15] || "",
                zonal_id: row[13] || "",
                head_brokerage: row[18] || "",
                head_id: row[16] || "",  
              });
            }
          });
          setEnable(true)
          setColumns(Object.keys(payload[0]))
        }
      }else{
          setDialogTittle(errorTitle)
          setDialogContent(`Please ensure your uploading a Monthly or Lifetime Brokerage or Transaction file`)
          setOpen(true)
        }
    }
    if(payload.length !==0){
      const fiveRecords = payload.slice(0,5)
      setPreview(fiveRecords)
      setRows(payload.length)
      setPayload(payload)
    }else {
      console.log("Empty")
    }
  }

  const sendData = async() => {
    try{
      if(type==="KYC"){
        setLoad(true)
        setOpen1(true)
        setDialogTittle1("Loading")
        setDialogContent1(gettingUploaded)
        const UploadData = await httpRequest({
          endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.kycUpload}`,
          method: "post",
          instance: "instanceOne",
          requestBody: payload
      })
      
      if(UploadData?.status === 200){
        setLoad(false)
        setDialogTittle1(uploadSuccTitle)
        setDialogContent1(uploadSuccBody)
        setOpen1(true)
      }else{
        setLoad(false)
        setDialogTittle(errorTitle)
        setDialogContent(errorBody)
        setOpen(true)
      }
      }else if (type==="Monthly Brokerage"){
        setLoad(true)
        setOpen1(true)
        setDialogTittle1("Loading")
        setDialogContent1(gettingUploaded)
        const UploadData = await httpRequest({
          endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.monthlyUpload}`,
          method: "post",
          instance: "instanceOne",
          requestBody: payload
      }) 
      if(UploadData?.status === 200){
            setLoad(false)
            setDialogTittle1(uploadSuccTitle)
            setDialogContent1(uploadSuccBody)
            setOpen1(true)
        }
        else{
            setLoad(false)
            setDialogTittle(errorTitle)
            setDialogContent(errorBody)
            setOpen(true)
        }      
      }
      else if(type==="Life Time Brokerage"){
        setLoad(true)
        setOpen1(true)
        setDialogTittle1("Loading")
        setDialogContent1(gettingUploaded)
        const UploadData = await httpRequest({
          endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.lifetimeUpload}`,
          method: "post",
          instance: "instanceOne",
          requestBody: payload
        })
        if(UploadData?.status === 200){
            setLoad(false)
            setDialogTittle1(uploadSuccTitle)
            setDialogContent1(uploadSuccBody)
            setOpen1(true)
        }
        else{
            setLoad(false)
            setDialogTittle(errorTitle)
            setDialogContent(errorBody)
            setOpen(true)
        }
      }else if(type==="Transactions"){ //dev-trupti on 23-12-2024
        setLoad(true)
        setOpen1(true)
        setDialogTittle1("Loading")
        setDialogContent1(gettingUploaded)
        const UploadData = await httpRequest({
          endPoint: `${backendHosts.DIPLOMAT}${apiUrl.transactionUpload}`,
          method: "post",
          instance: "instanceOne",
          requestBody: payload
        })
        if(UploadData?.status === 200){
            setLoad(false)
            setDialogTittle1(uploadSuccTitle)
            setDialogContent1(uploadSuccBody)
            setOpen1(true)
        }
        else{
            setLoad(false)
            setDialogTittle(errorTitle)
            setDialogContent(errorBody)
            setOpen(true)
        }
      }
      else{
          setDialogTittle(errorTitle)
          setDialogContent(`Please select the correct type`)
          setOpen(true)
      } 
    }catch(err){
      console.log(err,"An error occured")
    }
  }

  //dev-trupti on 11-12-2024
  const syncData = async() => {
    setLoad(true)
    setOpen1(true)
    setDialogTittle1("Loading")
    setDialogContent1("Please wait the data is syncing")
    if(type === "Profile Data"){ //dev-trupti on 23-12-2024
      try{
        const SyncData = await httpRequest({
          endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.profileSync}`,
          method: "post",
          instance: "instanceOne",
          headers : {
            'x-api-key': '08cd98f3-7aa0-4390-92d6-e952e672a116'
          }
        })
        if(SyncData?.status === 200){
          setLoad(false)
          setOpen1(true)
          setDialogTittle1("Profiles Successfully Synced")
          setDialogContent1(`Registration - ${SyncData?.data?.registration}, \nExpert Advice - ${SyncData?.data?.expert_advice}, \nWealth Vault - ${SyncData?.data?.wealth_vault}`)
        }else{
          setLoad(false)
          setOpen1(false)
          setOpen(true)
          setDialogTittle("Error Syncing Profiles Data")
          setDialogContent(`Something went wrong, please try again`)
        }
      }catch(err){
        console.log(err,"An Error Occured")
        setLoad(false)
        setOpen(true)
        setOpen1(false)
        setDialogTittle("Error Syncing Profiles Data")
        setDialogContent(errorBody)
      }
    }else if(type === "CRM Data"){
      try{
        const SyncData = await httpRequest({
          endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.crmSync}`, 
          method: "post",
          instance: "instanceOne",
          headers : {
            'x-api-key': '08cd98f3-7aa0-4390-92d6-e952e672a116'
          }
        })
        if(SyncData?.status === 200){
          setLoad(false)
          setOpen1(true)
          setDialogTittle1("CRM Data Successfully Synced")
          setDialogContent1(`Count - ${SyncData?.data?.crm_count}`)
        }else{
          setLoad(false)
          setOpen1(false)
          setOpen(true)
          setDialogTittle("Error Syncing CRM Data")
          setDialogContent(`Something went wrong, please try again`)
        }
      }catch(err){
        console.log(err,"An Error Occured")
        setLoad(false)
        setOpen(true)
        setOpen1(false)
        setDialogTittle("Error Syncing CRM Data")
        setDialogContent(errorBody)
      }
    }else if(type === "Portfolio"){ //dev-trupti on 10-04-2025
      try{
        httpRequest({
          endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.techxlPortfolioSync}`, 
          method: "post",
          instance: "instanceOne",
        })
          setLoad(false)
          setOpen1(true)
          setDialogTittle1("Syncing Tech XL Portfolio Data")
          setDialogContent1("The data synchronization process has started. This may take some time.")
      }catch(err){
        console.log(err,"An Error Occured")
        setLoad(false)
        setOpen(true)
        setOpen1(false)
        setDialogTittle("Error Syncing Tech XL Portfolio Data")
        setDialogContent(errorBody)
      }
  }
}

  return (
    <Grid className={classes.mainGrid}>
      <Grid className={classes.textGrid}>
        <Typography className={classes.campaignText}>Upload Files</Typography>
      </Grid>
      <Grid className={classes.typeGrid}>
      <FormControl size="small" >
        <InputLabel className={classes.inputColor} id="demo-select-small-label">Type</InputLabel>
        <Select
          className={classes.select}
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={type}
          label="Type"
          onChange={handleChange}
        >
          <MenuItem value={'Profile Data'}>Profile Data</MenuItem> {/* Corrected the order by dev-trupti on 09-01-2025 */}
          <MenuItem value={'CRM Data'}>CRM Data</MenuItem> {/* dev-trupti on 23-12-2024 */}
          <MenuItem value={'KYC'}>KYC</MenuItem>
          <MenuItem value={'Life Time Brokerage'}>Life Time Brokerage</MenuItem>
          <MenuItem value={'Monthly Brokerage'}>Monthly Brokerage</MenuItem>
          <MenuItem value={'Transactions'}>Remeshire</MenuItem>{/* dev-trupti on 24-12-2024 */}
          <MenuItem value={'Portfolio'}>Portfolio</MenuItem>{/* dev-trupti sync button on 10-04-2025 */} 
        </Select>
      </FormControl>

      {/* dev-trupti on 11-12-2024 */}
      {(type === "Profile Data" || type === "CRM Data" || type === "Portfolio") && <>
        <Grid className={classes.syncButton}>
          <Button onClick={()=>syncData()} className={classes.button} startIcon={<SyncIcon />}>Sync</Button>
        </Grid>
      </>}
      {(type === "KYC" || type === "Monthly Brokerage" || type === "Life Time Brokerage" || type === "Transactions") && <>
      <Grid className={classes.uploadGrid}>
        <Grid className={classes.uploadSubGrid}>
          <Button
                component="label"
                className={classes.chooseButton}
                variant="contained"
                tabIndex={-1}
                startIcon={<FileOpenIcon />}
              >
                Choose file
                <VisuallyHiddenInput
                  type="file"
                  onChange={(e) => {
                    getData(e);
                  }}
                  ref={(input) => {
                    if (input) {
                      // Reset the input after the file is selected to allow re-upload of the same file
                      input.value = null;
                    }
                  }}
                />
            </Button>
        </Grid >
        <Grid className={classes.sendbutton}>
          <Button onClick={()=>sendData()} disabled={!enable} className={enable? classes.button : classes.disabledButton} startIcon={<CloudUploadIcon />}>Upload</Button>
        </Grid>
      </Grid>
      <Typography className={classes.chooseText}>{file? file:null}</Typography>
      </>}
      </Grid>

      {enable && (
        <Grid className={type==="Transactions"? classes.previewGrid1 : classes.previewGrid}><Typography className={classes.fileHeading}>
          {fileName!==""? fileName:null} <span className={classes.previewText}>(Preview)</span>
        </Typography>
        <Typography className={classes.prevRows}>{rows !==0 ? `  ${rows} rows`:null}</Typography>
          <Grid className={classes.prevGrid} >
          <TableContainer component={Paper} >
            <Table>
              <TableHead className={classes.prevTableHead}>
                <TableRow>
                  {/* Dynamically create table headers */}
                  {columns?.map((col, index) => (
                    <TableCell className={classes.prevTableCell} key={index}><strong>{col.replace(/_/g, ' ')}</strong></TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className={classes.prevTableBody}>
                {/* Dynamically create rows based on the data */}
                {preview?.map((item, index) => (
                  <TableRow key={index} >
                    {columns?.map((col, colIndex) => (
                      <TableCell className={classes.prevTableBodyCell} key={colIndex}>{item[col]}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          </Grid>
        </Grid>
      )}


        {/* Error Dialog */}
        <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '480px', 
            height: '400px', 
          }
        }}
      >
        <Box className={classes.alertbox}><img src={error} height={200}></img></Box>
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle} >
          {dialogTittle}
        </DialogTitle>
          <DialogContentText id="alert-dialog-description" className={classes.dialogContentText}>
            {dialogContent}
          </DialogContentText>
        <DialogActions className={classes.dialogAction}>
          <Button className={classes.button} onClick={handleClose} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>


        {/* Success Dialog */}
      <Dialog
        open={open1}
        // onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '480px',  
            height: '400px', 
          }
        }}
      >
        <Box className={classes.alertbox}><img src={load? loader : success} height={200}></img></Box>
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle} >
          {dialogTittle1}
        </DialogTitle>
          <DialogContentText id="alert-dialog-description" className={classes.dialogContentText}>
            {dialogContent1}
          </DialogContentText>
        <DialogActions className={classes.dialogAction}>
          <Button disabled={load} className={!load? classes.button : classes.disabledButton} onClick={handleClose1} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};
export default withStyles(styles)(Uploads);
